<template>
  <div>
    <v-container>
      <v-row>
        <v-col
          v-for="(album, i) in albums"
          :key="i"
          cols="12"
          md="6"
          lg="3"
        >
          <v-card>
            <v-img
              class="white--text align-end"
              height="200px"
              :src="album.icon_url || 'https://fakeimg.pl/200x200/?text=preview'"
            >
            </v-img>

            <v-card-subtitle class="pb-0">{{album.title}}</v-card-subtitle>

            <v-card-text class="text--primary">{{album.outline}}</v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :to="`/home/creator/edit/${album.id}`"
              >
                Edit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="3"
        >
          <v-card>
            <v-img
              class="white--text align-end"
              height="200px"
              src="https://fakeimg.pl/360x360/?text=Create"
            >
            </v-img>
            <v-card-subtitle class="pb-0">--</v-card-subtitle>
            <v-card-text class="text--primary">建立屬於你的新專輯</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                to="/home/creator/create/"
              >
                Create
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { getOwnedAlbums } from '@/lib/album'
export default {
  data(){
    return {
      albums: []
    }
  },
  mounted(){
    this.resetAlbums()
  },
  methods: {
    async resetAlbums(){
      this.albums = (await getOwnedAlbums()).data
    }
  }
}
</script>

<style>

</style>
